/**
 * Decode JWT token and extract payload
 */
export const decodeJwtPayload = (token: string): any | null => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error decoding JWT token:', error);
    return null;
  }
};

/**
 * Check if JWT token is expired
 */
export const isTokenExpired = (token: string): boolean => {
  const payload = decodeJwtPayload(token);
  if (!payload || !payload.exp) {
    return true; // If no expiration, consider it expired
  }

  // exp is in seconds, Date.now() is in milliseconds
  const expirationTime = payload.exp * 1000;
  const now = Date.now();

  return now >= expirationTime;
};

/**
 * Get token expiration date
 */
export const getTokenExpiration = (token: string): Date | null => {
  const payload = decodeJwtPayload(token);
  if (!payload || !payload.exp) {
    return null;
  }

  // exp is in seconds, convert to milliseconds
  return new Date(payload.exp * 1000);
};
